<template>
  <div class="ui-download-nfplus-wrapper" @click="handleClickDownload">
    <img :src="downloadBg" class="img-download" v-if="downloadBg" />
  </div>
</template>

<script>
import openApp from "@/utils/openApp"
import { mapGetters } from "vuex"

const PC_DOWNLOAD = "https://static.nfapp.southcn.com/nfapp/index.html"

export default {
  name: "uiDownloadNfPlus",
  props: {
    isPC: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClickDownload() {
      if (this.isPC) {
        this.handleOpenDownload()
      } else {
        this.handleOpenApp()
      }
    },
    handleOpenDownload() {
      window.open(PC_DOWNLOAD)
    },
    handleOpenApp() {
      const address = `${window.location.href}`
      openApp({ address, activityId: this.activityId })
    }
  },
  computed: {
    ...mapGetters({
      downloadBg: "activityInfo/downloadBg",
      activityId: "activityInfo/activityId"
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-download-nfplus-wrapper {
  width: 3.76rem;
  height: 0.88rem;
  margin: 0 auto;
  .img-download {
    width: 100%;
    height: 100%;
  }
  &:active {
    opacity: 0.7;
  }
}
.ui-download-nfplus-wrapper.pc {
  width: 188px;
  height: 44px;
}
</style>
